import React from 'react';
import Card from 'components/general/Card/Card';
import Icon from 'components/general/Icon/Icon';
import Button from 'components/general/Button/Button';
import UserRiskRatings from './../containers/UserRiskRatings';
import UserAlertsSubHeader from './../containers/UserAlertsSubHeader';
import UserAlertsList from './../containers/UserAlertsList';
import UserArticlesSubHeader from './../containers/UserArticlesSubHeader';
import UserArticlesList from './../containers/UserArticlesList';
import SubHeader from "../../../components/general/SubHeader/SubHeader";

/**
 * Entity lists for users with preferences.
 * @todo Be smarter about this, have a 'widget' component and a set of
 * preference keys passed in which correspond. Then we can show/hide generically.
 */
const UserLists = ({
  hasSetRatings,
  hasSetAlerts,
  hasSetArticles,
}) => (
  <div className="page-section page-section--muted l-dashboard">
    {hasSetRatings ? (
      <Card className="l-dashboard__widget l-dashboard__widget--risks">
        <Card.Section>
          <UserRiskRatings />
        </Card.Section>
      </Card>
    ) : (
      <Card
        className="l-dashboard__widget l-dashboard__widget--risks"
        types={['empty']}
      >
        <Card.Section>
          <SubHeader
            title="Ratings"
          />
          <p>Set your rating preferences to see ratings for specific risk-types and countries.</p>
          <Button
            to={{ type: 'PREFERENCES_INTERESTS' }}
            types={['accent']}
          >
            Set rating preferences
          </Button>
        </Card.Section>
      </Card>
    )}
    {hasSetAlerts ? (
      <Card className="l-dashboard__widget">
        <Card.Section>
          <UserAlertsSubHeader />
          <UserAlertsList />
        </Card.Section>
      </Card>
    ) : (
      <Card
        className="l-dashboard__widget"
        types={['empty']}
      >
        <Card.Section>
          <SubHeader
            title="Alerts"
          />
          <p>Set your alert preferences to see alerts for specific risk-types and countries.</p>
          <Button
            to={{ type: 'PREFERENCES_INTERESTS' }}
            types={['accent']}
          >
            Set alert preferences
          </Button>
        </Card.Section>
      </Card>
    )}
    {hasSetArticles ? (
      <Card className="l-dashboard__widget">
        <Card.Section>
          <UserArticlesSubHeader />
          <UserArticlesList />
        </Card.Section>
      </Card>
    ) : (
      <Card
        className="l-dashboard__widget"
        types={['empty']}
      >
        <Card.Section>
          <SubHeader
            title="Articles"
          />
          <p>Set your article preferences to see articles for specific risk-types and regions.</p>
          <Button
            to={{ type: 'PREFERENCES_INTERESTS' }}
            types={['accent']}
          >
            Set article preferences
          </Button>
        </Card.Section>
      </Card>
    )}
  </div>
);

export default UserLists;

